import { BROADCAST_GET_GLOBAL_BANNER_TEMPLATES } from 'actions/Types';

export const initialState = [];

export default (state = initialState, action) => {
  if (action.type === `${BROADCAST_GET_GLOBAL_BANNER_TEMPLATES}_SUCCESS`) {
    return action.payload;
  }

  return state;
};
